import load from './load';
import sound from './sound';
import utils from './utils';
import MovieClip from './MovieClip';
import Scene from './Scene';
import ShapesCache from './ShapesCache';
import SymbolLoader from './SymbolLoader';
import Timeline from './Timeline';
import Tween from './Tween';
import Animator from './Animator';
import AnimatorTimeline from './AnimatorTimeline';

const VERSION = __VERSION__;

/**
 * @namespace PIXI.animate
 */
export {
    Animator,
    AnimatorTimeline,
    load,
    sound,
    utils,
    MovieClip,
    Scene,
    ShapesCache,
    SymbolLoader,
    Timeline,
    Tween,
    VERSION
};